import React from "react";
import moment from "moment";
import { Calendar3, ClockHistory, Person } from "react-bootstrap-icons";
import { formatCustomerDisplayName } from "../../services";
import {
  CustomerAvatar,
  CUSTOMER_TYPE,
  isCustomerDischarged,
  isCustomerListActive,
} from "../../shared";
import { ViewHistoryButton } from "./CustomerChangeHistoryModal";

const formatMetaDate = (value) => {
  if (value == null || String(value).trim() === "") return "—";
  const parsed = moment(
    value,
    ["MM/DD/YYYY", "M/D/YYYY", "YYYY-MM-DD", moment.ISO_8601],
    true
  );
  if (parsed.isValid()) return parsed.format("MMM D, YYYY");
  const fallback = moment(value);
  return fallback.isValid() ? fallback.format("MMM D, YYYY") : String(value);
};

const statusPresentation = (customer) => {
  const type = `${customer?.type || ""}`.trim().toLowerCase();
  if (type === CUSTOMER_TYPE.TRANSFERRED || type === "transferred") {
    return { label: "Transferred", tone: "neutral" };
  }
  if (type === CUSTOMER_TYPE.DECEASED || type === "deceased") {
    return { label: "Deceased", tone: "neutral" };
  }
  if (isCustomerDischarged(customer)) {
    return { label: "Discharged", tone: "inactive" };
  }
  if (isCustomerListActive(customer) || `${customer?.status || ""}`.trim().toLowerCase() === "active") {
    return { label: "Active", tone: "active" };
  }
  return { label: "Inactive", tone: "inactive" };
};

const CustomerInfoProfileBar = ({ customer, onViewHistory }) => {
  if (!customer) return null;
  const status = statusPresentation(customer);

  return (
    <div className="customer-info-profile-bar">
      <div className="customer-info-profile-main">
        <CustomerAvatar
          customerId={customer.id || customer._id}
          alt={formatCustomerDisplayName(customer)}
          size={72}
          lazy={false}
          borderRadius="50%"
          className="customer-info-profile-avatar"
        />
        <div className="customer-info-profile-identity">
          <div className="customer-info-profile-name">
            {formatCustomerDisplayName(customer)}
          </div>
          <div className="customer-info-profile-status-label">Customer Status</div>
          <span className={`customer-info-status-badge is-${status.tone}`}>
            <span className="customer-info-status-dot" />
            {status.label}
          </span>
          <div className="customer-info-profile-history-wrap">
            <ViewHistoryButton onClick={onViewHistory} />
          </div>
        </div>
      </div>
      <div className="customer-info-profile-meta">
        <div className="customer-info-profile-meta-row">
          <Calendar3 size={16} aria-hidden />
          <div>
            <div className="customer-info-profile-meta-label">Date Created</div>
            <div className="customer-info-profile-meta-value">
              {formatMetaDate(customer.create_date)}
            </div>
          </div>
        </div>
        <div className="customer-info-profile-meta-row">
          <Person size={16} aria-hidden />
          <div>
            <div className="customer-info-profile-meta-label">Created By</div>
            <div className="customer-info-profile-meta-value">
              {customer.create_by || "—"}
            </div>
          </div>
        </div>
        <div className="customer-info-profile-meta-row">
          <ClockHistory size={16} aria-hidden />
          <div>
            <div className="customer-info-profile-meta-label">Last Updated</div>
            <div className="customer-info-profile-meta-value">
              {formatMetaDate(customer.edit_date || customer.updatedAt)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerInfoProfileBar;
